class ScrollEffectItem {
  constructor($el) {
    this.isFadein = false;
    this.$el = $el;
  }
}

class ScrollEffectManager {
  constructor() {
    this.windowHeight = window.innerHeight;
    this.items = [];
  }
  clear() {
    for (let i = 0; i < this.items.length; i++) {
      this.items[i] = null;
    }
    this.items = [];
  }

  append($target) {
    this.items.push(new ScrollEffectItem($target));
  }

  onWindowResize() {
    this.windowHeight = window.innerHeight;
  }

  update(scrollTop) {
    for (let i = 0; i < this.items.length; i++) {
      if (
        !this.items[i].isFadein &&
        scrollTop >
          this.items[i].$el.offset()['top'] - this.windowHeight * 0.875
      ) {
        this.items[i].isFadein = true;
        this.items[i].$el.addClass('is-show');
      }
    }
  }
}

export default ScrollEffectManager;
